// import { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { FaCheckCircle, FaArrowRight, FaBed, FaUsers, FaCalendarCheck, FaAward } from "react-icons/fa";
// import HeroSlider from "../components/HeroSlider";
// import SectionTitle from "../components/SectionTitle";
// import RoomCard from "../components/RoomCard";
// import BookingForm from "../components/BookingForm";
// import Testimonials from "../components/Testimonials";
// import CTASection from "../components/CTASection";
// import Counter from "../components/Counter";
// import { roomsData } from "../data/roomsData";
// import { amenitiesData } from "../data/amenitiesData";
// import "../styles/Home.css";

// const Home = () => {
//   useEffect(() => {
//     document.title = "USHA Resort, Patna | Luxury Resort, Banquet & Wedding Venue";
//   }, []);

//   return (
//     <>
//       <HeroSlider />

//       {/* ---------- Welcome / About preview ---------- */}
//       <section className="welcome">
//         <div className="container welcome-grid">
//           <div className="welcome-media">
//             <img className="img-1" src="https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&w=900&q=80" alt="USHA Resort Patna" />
//             <img className="img-2" src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=700&q=80" alt="Resort dining" />
//             <div className="welcome-badge"><strong>12+</strong><span>Years of Hospitality</span></div>
//           </div>

//           <div className="welcome-content">
//             <SectionTitle tag="Welcome to USHA Resort" title="A Perfect Blend of Luxury & Nature" align="left" />
//             <p>
//               Nestled in the heart of Patna, USHA Resort is a peaceful escape from the busy city life —
//               offering elegant rooms, a sparkling swimming pool, lush green lawns and warm, personal hospitality.
//             </p>
//             <p>
//               Whether it is a romantic getaway, a family weekend, or the wedding of your dreams,
//               our team makes every moment special.
//             </p>
//             <ul className="welcome-list">
//               {["Luxurious AC Rooms & Suites", "Swimming Pool & Sun Deck", "Grand Banquet & Wedding Lawns", "Multi-Cuisine Restaurant"].map((item) => (
//                 <li key={item}><FaCheckCircle /> {item}</li>
//               ))}
//             </ul>
//             <Link to="/about" className="btn btn-primary">Know More About Us <FaArrowRight /></Link>
//           </div>
//         </div>
//       </section>

//       {/* ---------- Stats ---------- */}
//       <section className="stats">
//         <div className="container stats-grid">
//           <div className="stat-item"><FaBed /><h3><Counter end={11} suffix="+" /></h3><p>Luxury Rooms</p></div>
//           <div className="stat-item"><FaCalendarCheck /><h3><Counter end={200} suffix="+" /></h3><p>Events Hosted</p></div>
//           <div className="stat-item"><FaUsers /><h3><Counter end={5000} suffix="+" /></h3><p>Happy Guests</p></div>
//           <div className="stat-item"><FaAward /><h3><Counter end={4} suffix="+" /></h3><p>Years of Excellence</p></div>
//         </div>
//       </section>

//       {/* ---------- Featured rooms ---------- */}
//       <section>
//         <div className="container">
//           <SectionTitle
//             tag="Accommodation"
//             title="Our Featured Rooms"
//             subtitle="Elegantly designed rooms and suites with all the modern comforts you need for a relaxing stay."
//           />
//           <div className="rooms-grid gap-top">
//             {roomsData.slice(0, 3).map((room) => <RoomCard key={room.id} room={room} />)}
//           </div>
//           <div className="rooms-more">
//             <Link to="/rooms" className="btn btn-outline-dark">View All Rooms</Link>
//           </div>
//         </div>
//       </section>

//       {/* ---------- Amenities preview ---------- */}
//       <section className="amenities-section">
//         <div className="container">
//           <SectionTitle
//             tag="Facilities"
//             title="Resort Amenities"
//             subtitle="Everything you need for leisure, celebration and comfort — all in one beautiful place."
//           />
//           <div className="amenities-grid gap-top">
//             {amenitiesData.slice(0, 6).map(({ icon: Icon, title, desc }) => (
//               <div className="amenity-card" key={title}>
//                 <div className="amenity-icon"><Icon /></div>
//                 <h3>{title}</h3>
//                 <p>{desc}</p>
//               </div>
//             ))}
//           </div>
//           <div className="rooms-more">
//             <Link to="/amenities" className="btn btn-outline-dark">View All Amenities</Link>
//           </div>
//         </div>
//       </section>

//       <CTASection />
//       <Testimonials />

//       {/* ---------- Booking ---------- */}
//       <section className="booking-section" id="booking">
//         <div className="container">
//           <SectionTitle
//             tag="Reservation"
//             title="Book Your Stay"
//             subtitle="Fill in your details and our team will confirm availability instantly on WhatsApp."
//           />
//           <BookingForm />
//         </div>
//       </section>
//     </>
//   );
// };

// export default Home;


import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaArrowRight, FaBed, FaUsers, FaCalendarCheck, FaAward } from "react-icons/fa";
import HeroSlider from "../components/HeroSlider";
import SectionTitle from "../components/SectionTitle";
import RoomCard from "../components/RoomCard";
import BookingForm from "../components/BookingForm";
import GoogleReviews from "../components/GoogleReviews";   // 👈 Elfsight widget (replaces Testimonials)
import CTASection from "../components/CTASection";
import Counter from "../components/Counter";
import { roomsData } from "../data/roomsData";
import { amenitiesData } from "../data/amenitiesData";
import "../styles/Home.css";

const Home = () => {
  useEffect(() => {
    document.title = "USHA Resort, Patna | Luxury Resort, Banquet & Wedding Venue";
  }, []);

  return (
    <>
      <HeroSlider />

      {/* ---------- Welcome / About preview ---------- */}
      <section className="welcome">
        <div className="container welcome-grid">
          <div className="welcome-media">
            <img className="img-1" src="/images/Slider/16.jpeg" alt="USHA Resort Patna" />
            {/* <img className="img-2" src="/images/Slider/2.png" alt="Resort dining" /> */}
            <div className="welcome-badge"><strong>4+</strong><span>Years of Hospitality</span></div>
          </div>

          <div className="welcome-content">
            <SectionTitle tag="Welcome to USHA Resort" title="A Perfect Blend of Luxury & Nature" align="left" />
            <p>
              Nestled in the heart of Patna, USHA Resort is a peaceful escape from the busy city life —
              offering elegant rooms, a sparkling swimming pool, lush green lawns and warm, personal hospitality.
            </p>
            <p>
              Whether it is a romantic getaway, a family weekend, or the wedding of your dreams,
              our team makes every moment special.
            </p>
            <ul className="welcome-list">
              {["Luxurious AC Rooms & Suites", "Swimming Pool", "Grand Banquet", "Wedding Lawns"].map((item) => (
                <li key={item}><FaCheckCircle /> {item}</li>
              ))}
            </ul>
            <Link to="/about" className="btn btn-primary">Know More About Us <FaArrowRight /></Link>
          </div>
        </div>
      </section>

      {/* ---------- Stats ---------- */}
      <section className="stats">
        <div className="container stats-grid">
          <div className="stat-item"><FaBed /><h3><Counter end={11} suffix="+" /></h3><p>Luxury Rooms</p></div>
          <div className="stat-item"><FaCalendarCheck /><h3><Counter end={200} suffix="+" /></h3><p>Events Hosted</p></div>
          <div className="stat-item"><FaUsers /><h3><Counter end={5000} suffix="+" /></h3><p>Happy Guests</p></div>
          <div className="stat-item"><FaAward /><h3><Counter end={4} suffix="+" /></h3><p>Years of Excellence</p></div>
        </div>
      </section>

      {/* ---------- Featured rooms ---------- */}
      <section>
        <div className="container">
          <SectionTitle
            tag="Accommodation"
            title="Our Featured Rooms"
            subtitle="Elegantly designed rooms and suites with all the modern comforts you need for a relaxing stay."
          />
          <div className="rooms-grid gap-top">
            {roomsData.slice(0, 3).map((room) => <RoomCard key={room.id} room={room} />)}
          </div>
          <div className="rooms-more">
            <Link to="/rooms" className="btn btn-outline-dark">View All Rooms</Link>
          </div>
        </div>
      </section>

      {/* ---------- Amenities preview ---------- */}
      <section className="amenities-section">
        <div className="container">
          <SectionTitle
            tag="Facilities"
            title="Resort Amenities"
            subtitle="Everything you need for leisure, celebration and comfort — all in one beautiful place."
          />
          <div className="amenities-grid gap-top">
            {amenitiesData.slice(0, 6).map(({ icon: Icon, title, desc }) => (
              <div className="amenity-card" key={title}>
                <div className="amenity-icon"><Icon /></div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
          <div className="rooms-more">
            <Link to="/amenities" className="btn btn-outline-dark">View All Amenities</Link>
          </div>
        </div>
      </section>

      <CTASection />

      {/* ---------- Google Reviews (Elfsight widget) ---------- */}
      <GoogleReviews />

      {/* ---------- Booking ---------- */}
      <section className="booking-section" id="booking">
        <div className="container">
          <SectionTitle
            tag="Reservation"
            title="Book Your Stay"
            subtitle="Fill in your details and our team will confirm availability instantly on WhatsApp."
          />
          <BookingForm />
        </div>
      </section>
    </>
  );
};

export default Home;